module.exports = __webpack_public_path__ + "media/markers/marker-transparent-green-0e80b52e.svg";